<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="連携アカウント"
        @hide="close"
        hide-footer>
        <template>
            <div class="form-group m-form__group">
                <label for="linked_account">連携中のアカウント</label>
                <input
                    v-model="linkedAccountEmail"
                    id="linked_account"
                    name="linked_account"
                    class="form-control m-input"
                    type="text"
                    :disabled="true">
            </div>

            <div
                v-if="googleCalendars === null"
                class="d-flex justify-content-center align-items-center p-5">
                <b-spinner variant="yokumiru-doctor"/>
            </div>
            <div
                v-else
                class="form-group m-form__group">
                <label for="google_calendar">どのカレンダーと連携しますか？</label>
                <select
                    v-model="linkedCalendarId"
                    class="form-control"
                    type="text"
                    :disabled="inProgress">
                    <option :value="null">選択してください</option>
                    <option
                        v-for="calendar in googleCalendars"
                        :key="calendar.id"
                        :value="calendar.id">
                        {{ calendar.google_calendar_summary }}
                    </option>
                </select>
            </div>

            <div class="mt-4 mb-2 d-flex justify-content-center" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <b-button
                    class="btn btn-yokumiru-blue"
                    @click="onSave"
                    :disabled="initialLinkedCalendarId === linkedCalendarId">
                    設定を保存
                </b-button>
                <b-button
                    class="btn btn-yokumiru-red mx-2"
                    @click="onLinkCancel">
                    連携を解除
                </b-button>
                <b-button
                    class="btn btn-yokumiru-gray"
                    @click="close">
                    閉じる
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        props: {
            doctor: {
                type: Object,
                required: true,
            },
        },
        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                inProgress: false,
                linkedAccountEmail: '',
                linkedCalendarId: null,
                initialLinkedCalendarId: null,
                googleCalendars: null,
            };
        },

        created: function() {
            this.linkedAccountEmail = this.doctor.google_social_account.provider_doctor_email
            bus.$on('open-modal-doctor-google-account-link', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-google-account-link')
        },

        methods: {
            open: async function () {
                this.modalShow = true
                await this.fetchGoogleCalendars()
                this.setInitialCalendar()
            },

            close: function () {
                this.modalShow = false
            },

            /**
             * Googleカレンダー一覧取得
             */
            fetchGoogleCalendars: function () {
                this.googleCalendars = null

                return axios.get(`${constants.doctor.google_calendars.endpoint.base}`)
                    .then(({data}) => {
                        this.googleCalendars = data.data
                    })
                    .catch(({response}) => {
                        if (
                            response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('message') &&
                            response.data.message.includes('Invalid Credentials')
                        ) {
                            this.googleCalendars = []
                            bus.$emit('alert-danger', 'Googleアカウントの認証に失敗しました。アカウント連携をやり直してください。')
                        }
                    })
            },

            /**
             * Googleカレンダーの初期選択状態をセット
             */
            setInitialCalendar: function () {
                if (!this.googleCalendars || this.googleCalendars.length === 0) {
                    return null
                }

                // 連携中のカレンダーを探す（is_link = true）
                const linkedCalendar = this.googleCalendars.find((calendar) => calendar.is_link)
                if (linkedCalendar) {
                    this.linkedCalendarId = linkedCalendar.id
                    this.initialLinkedCalendarId = linkedCalendar.id
                    return
                }
                return null
            },

            onSave: async function () {
                if (this.inProgress) return
                this.inProgress = true
                
                const endpoint = `${constants.doctor.google_calendars.endpoint.base}/${this.linkedCalendarId}/link`

                await axios.put(endpoint)
                    .then(({data}) => {
                        bus.$emit('alert-success', 'Googleカレンダー連携を設定しました')
                        bus.$emit('change-link-calendar')
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response
                            && response.hasOwnProperty('data')
                            && response.data.hasOwnProperty('errors')
                            && response.data.errors.hasOwnProperty('message')) {
                            this.errors = {}
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            onLinkCancel: function () {
                this.close()
                this.$emit('on-link-cancel')
            },
        },
    }
</script>

<style scoped lang="scss">
.btn {
    width: 200px;
}
</style>
